import './scss/index.scss';
import { dcFactory } from 'dc';
import { AccountPreferencesFormComponent } from './js/account-preferences-form.component';

dcFactory.register(AccountPreferencesFormComponent);
